module.exports = __webpack_public_path__ + "img/logo.5b8f40c4.svg";